import { NgModule, Compiler, Component, ViewChild, ViewContainerRef, Input } from '@angular/core';

@Component({
  selector: 'dynamic-html',
  template: `
    <div #container></div>
  `,
})
export class DynamicHTML {
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  @Input() 
  src: string;
  
  constructor(private compiler: Compiler) {}

  ngAfterViewInit() {
    // this.addComponent('<u>Example templategdfgfdgfd</u>');
  }
  ngOnChanges() {
      if (!this.src) return;
      this.addComponent(this.src);
  }
  private addComponent(template: string) {
    @Component({template: template})
    class TemplateComponent {}

    @NgModule({declarations: [TemplateComponent]})
    class TemplateModule {}

    const mod = this.compiler.compileModuleAndAllComponentsSync(TemplateModule);
    const factory = mod.componentFactories.find((comp) =>
      comp.componentType === TemplateComponent
    );
    // const component = this.container.createComponent(factory);
    this.container.createComponent(factory);
  }
}


// WEBPACK FOOTER //
// ./src/modules/dynamic-html/dynamic-html.ts